import { toDateTimeString } from "../date_utils";
import { TableDef } from "../table_def";
import { mapTaskTypeRecheck } from "../db_utils";

export const TaskDef = new TableDef("task", {
    seq: {
        label: "编号",
    },
    name: {
        label: "任务名称",
    },
    priority: {
        label: "优先级",
    },
    completed_at: {
        label: "巡检时间",
        display: (item) => toDateTimeString(item.completed_at),
    },
    owner_creater: {
        label: "创建人",
        display: (item) => item.owner_creater?.name,
    },
    owner_checker: {
        label: "巡检人",
        display: (item) => item.owner_checker?.name,
    },
    owner_annotator: {
        label: "标注人",
        display: (item) => item.owner_annotator?.name,
    },
    owner_rechecker: {
        label: "复核人",
        display: (item) => item.owner_rechecker?.name,
    },
    type_recheck: {
        label: "复核方式",
        display: (item) => mapTaskTypeRecheck[item.type_recheck]?.text,
    },
    turbines: {
        label: "风机",
        display: (item) =>
            (item.turbines || []).map((turbine) => turbine?.name).join("\n"),
    },
    field_item: {
        label: "风场名称",
        display: (item) => item?.turbines?.[0]?.field_item?.name,
    },
    status: {
        label: "状态",
    },
    description: {
        label: "备注",
    },
    created_at: {
        label: "创建时间",
        display: (item) => toDateTimeString(item.created_at),
    },
    updated_at: {
        label: "更新时间",
        display: (item) => toDateTimeString(item.updated_at),
    },
});

export const getTask = async (db, taskId) => {
    let query = `select *, 
        (select *, 
         (select * from leaf where turbine = $parent.id order by attach_id asc) as leafs 
        from turbine where $parent.turbines contains id) as turbines
     from ONLY type::thing($taskId) fetch owner_checker,owner_annotator,owner_rechecker,owner_creater,turbines,turbines.*,turbines.*.field_item`;
    let [task] = await db.query(query, {
        taskId,
    });
    return task;
};
